import * as React from 'react'

import { observer } from 'mobx-react'

import ILogisticItem from '~/client/src/shared/models/ILogisticItem'

import LogisticsGanttStore from '../LogisticsGantt.store'
import LogisticsTimelineDays from './components/LogisticsTimelineDays'
import LogisticsTimelineHours from './components/LogisticsTimelineHours'

interface IProps {
  logisticItem: ILogisticItem
  logisticsGanttStore: LogisticsGanttStore
}

@observer
export default class LogisticsTimelineCell extends React.Component<IProps> {
  public componentDidMount() {
    const { isOneDayView, startTimeTracking } = this.props.logisticsGanttStore
    if (isOneDayView) {
      startTimeTracking()
    }
  }

  public componentWillUnmount() {
    this.props.logisticsGanttStore.stopTimeTracking()
  }

  public render() {
    const { logisticItem, logisticsGanttStore } = this.props
    const { isOneDayView } = logisticsGanttStore

    return (
      <div className="logistics-timeline-cell full-width full-height row">
        {isOneDayView ? (
          <LogisticsTimelineHours
            logisticItem={logisticItem}
            logisticsGanttStore={logisticsGanttStore}
          />
        ) : (
          <LogisticsTimelineDays
            logisticItem={logisticItem}
            logisticsGanttStore={logisticsGanttStore}
          />
        )}
      </div>
    )
  }
}
